var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPathAngular(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2648_2425)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.0459 20.0834L59.5494 0.307617L116.548 19.7317L107.319 93.1656L59.5494 119.621L12.5275 93.5172L4.0459 20.0834Z",
    fill: "#E23237"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.547 19.7317L59.5488 0.307617V119.621L107.318 93.2097L116.547 19.7317Z",
    fill: "#B52E31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.6369 14.2388L25.0518 91.1883L37.9716 90.9686L44.9153 73.6097H75.941L83.5438 91.1883L95.8923 91.408L59.6369 14.2388ZM59.7251 38.8926L71.4145 63.3263H49.4413L59.7251 38.8926Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2648_2425"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 112.944,
    height: 120,
    fill: "white",
    transform: "translate(4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPathAngular);
export default __webpack_public_path__ + "static/media/path-angular.b8aa178be1cf25d2bc4b853f74b06f2f.svg";
export { ForwardRef as ReactComponent };